/**
 * Formats decimal hours as `"6h"` / `"5h 10m"`. Never omits the hour component,
 * even for sub-hour values (`0.75` → `"0h 45m"`).
 *
 * @example
 * formatHours(6.0)    // "6h"
 * formatHours(5.1667) // "5h 10m"
 * formatHours(0.75)   // "0h 45m"
 */
export function formatHours(decimalHours: number): string {
  let h = Math.floor(decimalHours);
  let m = Math.round((decimalHours - h) * 60);
  if (m === 60) {
    h += 1;
    m = 0;
  }
  return m > 0 ? `${h}h ${m}m` : `${h}h`;
}
